import { useCallback, useEffect, useRef } from "react";
import { Input, message } from "antd";
import styles from "./index.module.scss";
import { CompanyTag } from "@/components/company-tag";
import { Tag } from "@/components";
import { useCurrent } from "@/providers";
import {
  createSupplierTrackEvent,
  getSupplierTrackMemberLevel,
} from "@/services";
import { useNavigate } from "react-router-dom";
const { Search: AntSearch } = Input;

export const SimpleSearch = (props: any) => {
  const { supplierInfo } = props;
  const { memberQuotaBaseInfo } = useCurrent();
  const navigate = useNavigate();
  const caIdentityGuideRef = useRef<HTMLDivElement>(null);
  const caIdentityGuideExposedRef = useRef(false);
  const showCaIdentityGuide =
    supplierInfo?.isOwner !== true &&
    memberQuotaBaseInfo?.memberTypeCode !== "PREMIUM_PACKAGE" &&
    memberQuotaBaseInfo?.caMemberTypeCode !== "FADADA_CA_CERTIFIED" &&
    memberQuotaBaseInfo?.caOpenListHit === true;
  const memberLevel = getSupplierTrackMemberLevel(memberQuotaBaseInfo);

  const trackCaIdentityGuide = useCallback(
    (
      eventName: "guide_expose" | "guide_click",
      eventType: "EXPOSE" | "CLICK",
      elementName: string,
      properties: Record<string, unknown> = {},
    ) => {
      createSupplierTrackEvent({
        eventId: `evt_${crypto.randomUUID()}`,
        eventName,
        eventType,
        eventTime: Date.now(),
        slotId: "ca_portalhome_nametag",
        memberLevel,
        inOpenList: true,
        device: "pc",
        pageName: "portal_home",
        moduleName: "name_tag",
        elementName,
        properties,
      }).catch(() => undefined);
    },
    [memberLevel],
  );

  useEffect(() => {
    const guide = caIdentityGuideRef.current;
    if (!guide || !showCaIdentityGuide || caIdentityGuideExposedRef.current) {
      return;
    }

    let exposeTimer: ReturnType<typeof setTimeout> | undefined;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio >= 0.5) {
          if (!exposeTimer) {
            exposeTimer = setTimeout(() => {
              caIdentityGuideExposedRef.current = true;
              trackCaIdentityGuide("guide_expose", "EXPOSE", "name_tag", {
                visiblePercent: Math.round(entry.intersectionRatio * 100),
                visibleDurationMs: 1000,
              });
              observer.disconnect();
            }, 1000);
          }
          return;
        }

        if (exposeTimer) {
          clearTimeout(exposeTimer);
          exposeTimer = undefined;
        }
      },
      { threshold: [0, 0.5, 1] },
    );

    observer.observe(guide);
    return () => {
      if (exposeTimer) clearTimeout(exposeTimer);
      observer.disconnect();
    };
  }, [showCaIdentityGuide, trackCaIdentityGuide]);

  const handleCaIdentityGuideClick = () => {
    trackCaIdentityGuide("guide_click", "CLICK", "open_service", {
      buttonText: "点亮身份标签",
    });
    window.open("/caIntroduction", "_blank");
  };

  const onSearch = (v: string) => {
    if (!v) {
      message.warning("请输入供应商名称");
      return;
    }
    navigate(`/s/search?keyword=${v}`);
  };
  const { payed, payedSince, payedLevel, realNameAuthed, taxpayer } = supplierInfo || {};
  return (
    <div className={styles.simpleSearchWrapper}>
      <div className={styles.simpleSearchInner}>
        <div className={styles.simpleSearchLeft}>
          <img
            src="https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/daqihui-pc/logo.png"
            className={styles.simpleSearchLeftPng}
            style={{ cursor: "pointer" }}
            onClick={() => {
              navigate("/s");
            }}
          />
          <span className={styles.simpleSearchLine} />
          <div className={styles.simpleSearchContent}>
            <span>{supplierInfo?.companyName}</span>
            <div className={styles.simpleSearchIC}>
              {!!payed && (
                <CompanyTag year={payedSince} payedLevel={payedLevel} />
              )}
              {!!realNameAuthed && (
                <Tag
                  type="info"
                  title="已实名"
                  icon="yishiming"
                  style={{ marginBottom: 0 }}
                />
              )}
              {!!taxpayer && (
                <Tag
                  icon="yibannashuiren"
                  type="info"
                  title="一般纳税人"
                  style={{ marginBottom: 0 }}
                />
              )}
              {showCaIdentityGuide && (
                <div
                  ref={caIdentityGuideRef}
                  className={styles.caIdentityGuide}
                >
                  <span
                    className={styles.caIdentityInactiveTag}
                    onClick={handleCaIdentityGuideClick}
                  >
                    ✦ 未展示标签
                  </span>
                  <button
                    type="button"
                    className={styles.caIdentityGuideButton}
                    onClick={handleCaIdentityGuideClick}
                  >
                    点亮身份标签 ›
                  </button>
                </div>
              )}

              {/* <div className={styles.zmCredit}>
                <img src={zmCredit} />
                <div>{supplierInfo?.zmCreditLevel || '-'}</div>
              </div> */}
            </div>
          </div>
        </div>
        <div className={styles.simpleSearchRight}>
          <AntSearch
            placeholder="搜索您要找的供应商"
            allowClear
            enterButton="搜索"
            size="large"
            onSearch={onSearch}
          />
        </div>
      </div>
    </div>
  );
};
